import React from "react";
import "./suggesstion.css";
import { Button } from "reactstrap";
//import fetchApi from "../../common/fetchApi";
import axios from "axios";
import api from "../../routes/api";
import Avatar from "react-avatar";
import toast, { Toaster } from "react-hot-toast";
import socket from "../../helpers/socket";
import { useNavigate } from "react-router-dom";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  TumblrShareButton,
  VKShareButton,
  PinterestShareButton,
  RedditShareButton,
  EmailShareButton,
  WeiboShareButton,
} from "react-share";
import {
  FacebookIcon,
  FacebookMessengerIcon,
  LinkedinIcon,
  TwitterIcon,
  PinterestIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  VKIcon,
  TelegramIcon,
  EmailIcon,
  WeiboIcon,
} from "react-share";

const withNavigate = (Component) => (props) => {
  const navigate = useNavigate();
  return <Component {...props} navigate={navigate} />;
};

class Suggestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestion: [],
      userData: {},
      requestData: [],
    };
  }
  socket;
  arr = [];
  getSuggestion = async () => {
    //console.log("suggesstion");
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await axios({
      url: api.suggesstion + `/${user.data.data.id}`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (result.data.success) {
      this.setState({ suggestion: result.data.arr });
    } else {
      this.setState({ suggestion: [] });
    }
  };
  configureSocket = async () => {
    // const user = JSON.parse(localStorage.getItem('user'));
    // const token = user.data.token;
    // var socket = socketClient(api.localUrl, {
    //   query: { token }
    // });
    // socket.on('connection', () => {

    // });
    this.socket = socket;
    this.socket.on("connection", () => {});
  };
  socketJoin = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user != null) {
      let notify = {
        userId: user.data.data.id,
      };
      this.socket.emit("notification", notify);
    }
  };
  componentDidMount() {
    //console.log(this.props)
    const user = JSON.parse(localStorage.getItem("user"));
    if (user != null) {
      this.getSuggestion();
      this.getUserData();
      this.configureSocket();
      this.socketJoin();
    }
  }
  checkUser(request) {
    //console.log(request, "<==request")
    const user = JSON.parse(localStorage.getItem("user"));
    if (request.length != 0) {
      for (let i = 0; i < request.length; i++) {
        if (request[i].receiverId == user.data.data.id) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }
  getUserData = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await axios({
      method: "GET",
      url: api.getProfileData + `/${user.data.data.id}`,
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result.data.success) {
      this.setState({ userData: result.data.result });
    } else {
      this.setState({
        userData: {
          firstname: "",
          lastname: "",
          bio: "",
          hobbies: [],
          username: "",
          email: "",
          image: [],
        },
      });
    }
  };
  cancelRequest = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await axios({
      url: api.followRequest + `/${user.data.data.id}/${id}`,
      method: "POST",
      data: {
        action: "cancel",
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    //console.log(result, "<===follow request")
    if (result.data.success) {
      const request = {
        senderId: user.data.data.id,
        receiverId: id,
        notification: `${this.state.userData.firstname} send follow request`,
        username: this.state.userData.username,
        name: this.state.userData.firstname,
        image: this.state.userData.image,
        isRead: false,
      };
      //console.log(request, "request")
      this.getSuggestion();
      toast.success(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
    } else {
      toast.error(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
    }
  };
  followRequest = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await axios({
      url: api.followRequest + `/${user.data.data.id}/${id}`,
      method: "POST",
      data: {
        action: "request",
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    //console.log(result, "<===follow request")
    if (result.data.success) {
      // const request = {
      // 	senderId: user.data.data.id,
      // 	receiverId: id,
      // 	notification: `${this.state.userData.firstname} send follow request`,
      // 	username: this.state.userData.username,
      // 	name: this.state.userData.firstname,
      // 	image: this.state.userData.image,
      // 	isRead: false
      // }
      // //console.log(request, "request")
      // this.socket.emit('request', request);
      this.getSuggestion();
      toast.success(result.data.message);
    } else {
      toast.error(result.data.message);
    }
  };
  getRequestData = async () => {
    this.socket.on("requests", (data) => {
      this.arr.push(data);
      this.setState({ requestData: data });
    });
  };

  navigateUser = (id) => {
    return <UserProfile id={id} />;
  };

  render() {
    const { navigate } = this.props;
    return (
      <>
        <div className="chat-left-box">
          <div style={{ fontSize: "10px" }}>Invite Friends</div>
          <div style={{ marginTop: "5px", marginBottom: "5px" }}>
            <TwitterShareButton
              url={`https://fonolive.com/user-profile/${
                JSON.parse(localStorage.getItem("user")).data.data.id
              }`}
              title={"Please, join and follow me on Fonolive"}
            >
              <TwitterIcon size={32} round={true} />
            </TwitterShareButton>
            <FacebookShareButton
              url={`https://fonolive.com/user-profile/${
                JSON.parse(localStorage.getItem("user")).data.data.id
              }`}
              quote={"Please, join and follow me on Fonolive"}
            >
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
            <RedditShareButton
              url={`https://fonolive.com/user-profile/${
                JSON.parse(localStorage.getItem("user")).data.data.id
              }`}
              title={"Please, join and follow me on Fonolive"}
            >
              <RedditIcon size={32} round={true} />
            </RedditShareButton>
            <LinkedinShareButton
              url={`https://fonolive.com/user-profile/${
                JSON.parse(localStorage.getItem("user")).data.data.id
              }`}
              title={"Please, join and follow me on Fonolive"}
            >
              <LinkedinIcon size={32} round={true} />
            </LinkedinShareButton>
            <TelegramShareButton
              url={`https://fonolive.com/user-profile/${
                JSON.parse(localStorage.getItem("user")).data.data.id
              }`}
              title={"Please, join and follow me on Fonolive"}
            >
              <TelegramIcon size={32} round={true} />
            </TelegramShareButton>
            <WeiboShareButton
              url={`https://fonolive.com/user-profile/${
                JSON.parse(localStorage.getItem("user")).data.data.id
              }`}
              title={"Please, join and follow me on Fonolive"}
            >
              <WeiboIcon size={32} round={true} />
            </WeiboShareButton>
            <EmailShareButton
              url={`https://fonolive.com/user-profile/${
                JSON.parse(localStorage.getItem("user")).data.data.id
              }`}
              subject={"Please, join and follow me on Fonolive"}
              body={
                "Please, join and follow me on the Fonolive Social Marketplace"
              }
            >
              <EmailIcon size={32} round={true} />
            </EmailShareButton>
          </div>
          <h6
            className="poppins text-start text-dark"
            style={{ marginTop: "10px" }}
          >
            Suggestions
          </h6>
          <div className="bg-white p-3">
            {(Array.isArray(this.state.suggestion) &&
              this.state.suggestion.length) == 0 ? (
              <div className="text-dark">No suggesstion</div>
            ) : (
              <ul className="list-group">
                {this.state.suggestion.map((item, index) => {
                  return (
                    <li
                      className="d-flex justify-content-between align-items-center"
                      style={{ margin: ".5em 0" }}
                      key={index}
                    >
                      <div
                        className="curPointer"
                        onClick={() => {
                          // //console.log(this.props.props)
                          navigate(`/user-profile/${item._id}`);
                        }}
                      >
                        {item.image === "" ? (
                          <Avatar
                            size="35"
                            round={true}
                            name={item.firstname}
                            maxInitials={2}
                          />
                        ) : (
                          <img
                            width="35px"
                            height="35px"
                            src={item.image}
                            style={{ objectFit: "cover", borderRadius: "50%" }}
                            alt=""
                          />
                        )}
                      </div>
                      <div
                        className="fs-6 poppins ml-2 text-capitalize overflow-hidden curPointer"
                        style={{ color: "#000", textOverflow: "ellipsis" }}
                        onClick={() => navigate(`/user-profile/${item._id}`)}
                        title={item.firstname}
                      >
                        {item.firstname}
                      </div>
                      <div className="ml-auto recTime">
                        {item.isRequest ? (
                          <Button
                            className="ml-3 rounded fn-flw-btn"
                            size="sm"
                            type="button"
                            onClick={() => {
                              this.cancelRequest(item._id);
                            }}
                          >
                            Requested
                          </Button>
                        ) : (
                          <Button
                            className="ml-3 rounded fn-flw-btn"
                            style={{ background: "#545AF2", color: "#fff" }}
                            size="sm"
                            type="button"
                            onClick={() => {
                              this.followRequest(item._id);
                            }}
                          >
                            follow
                          </Button>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
        <Toaster />
      </>
    );
  }
}
export default withNavigate(Suggestion);

const UserProfile = ({ id }) => {
  const navigate = useNavigate();
  return navigate(`/user-profile/${id}`);
};
